import { getBaseFeature } from '@/assets/style/variable'

const bg1 = `url(${require('./images/bg-1.webp')}) left top / 100% auto no-repeat`
const bg2 = `url(${require('./images/bg-2.webp')}) left top / 100% auto no-repeat`

const sharedDefault = {
  '--repurchase-nav-bg': bg1,
  '--repurchase-banner-bg': `url(${require('./images/bg-1.webp')})`,
}

const styObj = {
  default: sharedDefault,
  vava: sharedDefault,
  joychat: sharedDefault,
  kiko: sharedDefault,
  echo: {
    '--repurchase-nav-bg': bg2,
    '--repurchase-banner-bg': `url(${require('./images/bg-2.webp')})`,
  },
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        if (styObj[this.packageName]) {
          return { ...getBaseFeature(), ...styObj[this.packageName] }
        }
        return { ...getBaseFeature(), ...styObj.default }
      }
      return { ...getBaseFeature() }
    },
  },
}
